/*
 * ActionBadge (Figma 119:15014): pill. Radius 32, padding 3px 8px, gap 4; 6px dot (radius 3);
 * text SemiBold 600 14/14. Colours per status: weak fill, status dot, status text.
 * PriorityLabel (badge in the priority cell): same layout, radius 4, NO fill.
 */
import { cx } from './cx'

export type Tone = 'success' | 'danger' | 'warning' | 'info' | 'neutral'

const TONE: Record<Tone, { fill: string; dot: string; text: string }> = {
    success: { fill: 'bg-[var(--status-success-weak)]', dot: 'bg-[var(--status-success)]', text: 'text-[var(--text-success)]' },
    danger: { fill: 'bg-[var(--status-danger-weak)]', dot: 'bg-[var(--status-danger)]', text: 'text-[var(--text-danger)]' },
    warning: { fill: 'bg-[var(--status-warning-weak)]', dot: 'bg-[var(--status-warning)]', text: 'text-[var(--text-warning)]' },
    info: { fill: 'bg-[var(--status-info-weak)]', dot: 'bg-[var(--status-info)]', text: 'text-[var(--text-info)]' },
    neutral: { fill: 'bg-[var(--status-neutral-weak)]', dot: 'bg-[var(--text-weaker)]', text: 'text-[var(--text-weak)]' },
}

function Dot({ tone }: { tone: Tone }) {
    return <span aria-hidden className={cx('size-[6px] shrink-0 rounded-[3px]', TONE[tone].dot)} />
}

const TEXT = 'whitespace-nowrap text-[14px] leading-[14px] font-semibold'

/** Status pill with a tinted background (e.g. "Täienda"). */
export function ActionBadge({ tone, children }: { tone: Tone; children: string }) {
    return (
        <span className={cx('inline-flex shrink-0 items-center gap-[4px] rounded-[32px] px-[8px] py-[3px] align-top', TONE[tone].fill)}>
            <Dot tone={tone} />
            <span className={cx(TEXT, TONE[tone].text)}>{children}</span>
        </span>
    )
}

/** Dot + coloured text, no background (e.g. priority "Kriitiline"). */
export function PriorityLabel({ tone, children }: { tone: Tone; children: string }) {
    return (
        <span className="inline-flex shrink-0 items-center gap-[4px] rounded-[4px] px-[8px] py-[3px] align-top">
            <Dot tone={tone} />
            <span className={cx(TEXT, TONE[tone].text)}>{children}</span>
        </span>
    )
}
